<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b-card-title>PD/UPD</b-card-title>
        <b-card-title class="text-primary">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="secondary"
            class="btn-icon"
            size="sm"
            :to="{ name: 'validasiKeberadaan' }"
          >
            <feather-icon icon="ArrowLeftIcon" />
          </b-button>
        </b-card-title>
      </b-card-header>

      <b-card-body>
        <b-form
          class="needs-validation"
          @submit.prevent="submitForm"
        >
          <b-form-row>
            <b-col
              md="10"
              offset-md="1"
            >
              <b-form-group
                label="Kode Lokasi"
                label-for="kodeLokasi"
              >
                <b-form-input
                  id="kodeBarang"
                  v-model="kolokVal"
                  disabled
                />
              </b-form-group>

              <b-form-group
                label="KIB"
                label-for="kib"
              >
                <b-form-input
                  id="kib"
                  v-model="kibVal"
                  disabled
                />
              </b-form-group>

              <b-form-group
                label="Kode Barang"
                label-for="kodeBarang"
              >
                <b-form-input
                  id="kodeBarang"
                  v-model="kobarVal"
                  disabled
                />
              </b-form-group>

              <b-form-group
                label="Nama Barang"
                label-for="namaBarang"
              >
                <b-form-input
                  id="namaBarang"
                  v-model="nabarVal"
                  disabled
                />
              </b-form-group>

              <b-form-group
                label="Kode Register Barang"
                label-for="kodeRegisterBarang"
              >
                <b-form-input
                  id="kodeRegisterBarang"
                  v-model="kodeRegisterBarangVal"
                  disabled
                />
              </b-form-group>
            </b-col>
          </b-form-row>
        </b-form>
      </b-card-body>
    </b-card>

    <b-card no-body>
      <b-card-header>
        <b-card-title>{{ titleCard }} (View Only)</b-card-title>
      </b-card-header>

      <b-card-body>
        <b-form class="needs-validation">
          <b-form-row>
            <b-col
              md="10"
              offset-md="1"
            >
              <b-table
                responsive
                :items="data1"
                :fields="fieldData1"
                striped
                bordered
                hover
              >
                <template #cell(value)="data">
                  <div v-if="data.item.key == 'Gambar'">
                    <img
                      v-if="data.value"
                      :src="data.value"
                      alt="Gambar"
                      style="max-width: 600px"
                    >
                  </div>
                  <div v-else>
                    <div v-if="typeof data.value == 'object'">
                      {{ data.value.value }}
                      <b-table
                        responsive
                        :items="data.value.detail"
                        :fields="fieldData1"
                        striped
                        bordered
                        hover
                      >
                        <template #cell(value)="data">
                          <div v-if="typeof data.value == 'object'">
                            <b-table
                              responsive
                              :items="data.value"
                              :fields="fieldData1"
                              striped
                              bordered
                              hover
                            />
                          </div>
                          <div v-else>
                            {{ data.value }}
                          </div>
                        </template>
                      </b-table>
                    </div>
                    <div v-else>
                      {{ data.value }}
                    </div>
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-form-row>
        </b-form>
      </b-card-body>
    </b-card>

    <b-card
      v-if="
        $can('Validasi', 'validasiKeberadaan') &&
          (statusVal == 2 || statusVal == 3)
      "
      no-body
    >
      <b-card-header>
        <b-card-title>Verifikasi P3B</b-card-title>
      </b-card-header>

      <b-card-body>
        <b-form
          class="needs-validation"
          @submit.prevent="submitForm"
        >
          <b-form-row>
            <b-col
              md="10"
              offset-md="1"
            >
              <b-form-group
                label="Status Persetujuan"
                label-for="statusPersetujuan"
              >
                <b-row>
                  <b-col md="3">
                    <b-form-radio
                      v-model="v$.statusPersetujuan.$model"
                      value="1"
                      :state="validateState(v$.statusPersetujuan)"
                    >
                      Setuju
                    </b-form-radio>
                  </b-col>
                  <b-col md="9">
                    <b-form-radio
                      v-model="v$.statusPersetujuan.$model"
                      value="0"
                      :state="validateState(v$.statusPersetujuan)"
                    >
                      Dikembalikan
                    </b-form-radio>
                  </b-col>
                </b-row>
                <small
                  v-for="(error, index) of v$.statusPersetujuan.$errors"
                  :key="index"
                  class="text-danger"
                >
                  <span>{{ error.$message }}</span>
                </small>
              </b-form-group>

              <b-form-group
                v-if="statusPersetujuan === '0'"
                label="Catatan"
                label-for="catatan"
              >
                <b-form-textarea
                  id="catatan"
                  v-model="v$.catatan.$model"
                  :state="validateState(v$.catatan)"
                />
                <b-form-invalid-feedback
                  v-for="(error, index) of v$.catatan.$errors"
                  :key="index"
                >
                  <span v-if="error.$validator == 'checkCatatan'">Catatan Harus di Isi Jika Tidak Setuju</span>
                  <span v-else>{{ error.$message }}</span>
                </b-form-invalid-feedback>
              </b-form-group>
              <b-col
                cols="12"
                class="pr-0 pt-2 pl-0"
              >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                >
                  <div v-if="isSubmit">
                    <b-spinner small />
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div v-else>
                    Validasi
                  </div>
                </b-button>
              </b-col>
            </b-col>
          </b-form-row>
        </b-form>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BForm,
  BFormRow,
  BCol,
  BFormInput,
  BFormValidFeedback,
  BFormInvalidFeedback,
  BCardHeader,
  BCardBody,
  BButton,
  BFormGroup,
  BCardTitle,
  BSpinner,
  BFormSelect,
  BTable,
  BRow,
  BFormTextarea,
} from 'bootstrap-vue'
import { required, helpers } from '@vuelidate/validators'
import useVuelidate from '@vuelidate/core'
import { ref, computed, watchEffect } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import validasiKeberadaan from '@/composables/validasiKeberadaan'
// import {generateYears, startYear, intThousand, setInputIntOnly, defaultYear} from '@/libs/helper'
const moment = require('moment')

const defaultString = { type: String, default: '' }

export default {
  directives: {
    Ripple,
  },
  components: {
    vSelect,
    BCard,
    BForm,
    BFormRow,
    BCol,
    BFormInput,
    BFormValidFeedback,
    BFormInvalidFeedback,
    BCardHeader,
    BCardBody,
    BButton,
    BFormGroup,
    BCardTitle,
    BSpinner,
    BFormSelect,
    BTable,
    BRow,
    BFormTextarea,
  },
  props: {
    kolokVal: String,
    kibVal: String,
    kobarVal: String,
    nabarVal: String,
    kodeRegisterBarangVal: String,
    keberadaanVal: String,
    wujudVal: String,

    alasanTidakAdaVal: String,
    alasanTidakAdaPVal: String,
    asetIndukVal: String,
    pdUkpdVal: String,
    kolokPdUkpdVal: String,
    kobarIndukVal: String,
    nabarIndukVal: String,
    registerBarangVal: String,
    alasanTidakAdaNoteVal: String,
    noSkPenghapusanVal: String,

    bagianDariAsetIndukVal: String,
    kondisiBarangVal: String,

    provinsiVal: String,
    kabKotaVal: String,
    kecamatanVal: String,
    kelurahanVal: String,
    jalanVal: String,
    noAlamatVal: String,
    rtVal: String,
    rwVal: String,
    kodePosVal: String,

    latitudeVal: String,
    longitudeVal: String,
    tanda2BatasTanahUtaraVal: String,
    tanda2BatasTanahTimurVal: String,
    tanda2BatasTanahSelatanVal: String,
    tanda2BatasTanahBaratVal: String,
    keteranganBetonVal: defaultString,
    keteranganBetonSebutkanVal: String,
    plangVal: String,
    plangPVal: String,
    pagarVal: String,
    pagarPVal: String,
    catatanVal: String,
    statusVal: String,
    peruntukkanVal: defaultString,
    gambarVal: String,
    isBertingkatVal: String,
    bertingkatSeharusnyaVal: String,
    kibSeharusnyaVal: String,
    kodeBarangSeharusnyaVal: String,
    kesesuaianKodeBarangVal: String,

    isShowUbahVal: Boolean,

    action: String,
    id: String,
  },
  setup(props, context) {
    const g = context.root

    const isSubmit = ref(false)

    // form name
    const kodeLokasi = ref('')
    const kib = ref('')
    const kodeBarang = ref('')
    const namaBarang = ref('')
    const kodeRegisterBarang = ref('')
    const catatan = ref('')

    const statusPersetujuan = ref(null)

    const dataKodeLokasi = ref([])
    const dataKib = ref([])

    const data1 = ref([])
    const fieldData1 = ref([
      {
        key: 'key',
        label: '',
      },
      {
        key: 'value',
        label: '',
      },
    ])

    const bukanBiayaBeban = 'Fisik Tidak Ditemukan'
    const yaBiayaBeban = 'Non Fisik/Biaya-Biaya'
    const biayaBeban = [
      yaBiayaBeban,
      yaBiayaBeban,
      yaBiayaBeban,
      bukanBiayaBeban,
      bukanBiayaBeban,
      bukanBiayaBeban,
      bukanBiayaBeban,
    ]

    const titleCard = ref('')

    watchEffect(() => {
      catatan.value = props.catatanVal
      statusPersetujuan.value = props.statusVal == 3 ? '0' : props.statusVal == 4 ? '1' : null

      if (props.keberadaanVal == 1) {
        titleCard.value = 'Bukan Biaya - Ada'
        data1.value = [
          {
            key: 'Keberadaan Fisik BMD',
            value: 'Ada',
          },
          {
            key: 'Kode Barang',
            value:
              props.kesesuaianKodeBarangVal == 1
                ? 'Sesuai Dengan Data Lama'
                : {
                  value: 'Tidak Sesuai Dengan Data Lama',
                  detail: [
                    {
                      key: 'KIB Seharusnya',
                      value: props.kibSeharusnyaVal,
                    },
                    {
                      key: 'Kode Barang Seharusnya',
                      value: props.kodeBarangSeharusnyaVal,
                    },
                  ],
                },
          },
          {
            key: 'Kondisi BMD',
            value:
              props.kondisiBarangVal == 2
                ? 'Baik'
                : props.kondisiBarangVal == 1
                  ? 'Rusak Ringan'
                  : props.kondisiBarangVal === '0'
                    ? 'Rusak Berat'
                    : '',
          },
          {
            key: 'Alamat',
            value: {
              detail: [
                {
                  key: 'Provinsi',
                  value: props.provinsiVal,
                },
                {
                  key: 'Kabupaten/Kota',
                  value: props.kabKotaVal,
                },
                {
                  key: 'Kecamatan',
                  value: props.kecamatanVal,
                },
                {
                  key: 'Kelurahan',
                  value: props.kelurahanVal,
                },
                {
                  key: 'Jalan',
                  value: props.jalanVal,
                },
                {
                  key: 'No',
                  value: props.noAlamatVal,
                },
                {
                  key: 'RT',
                  value: props.rtVal,
                },
                {
                  key: 'RW',
                  value: props.rwVal,
                },
                {
                  key: 'Kode Pos',
                  value: props.kodePosVal,
                },
              ],
            },
          },
          {
            key: 'Koordinat',
            value: {
              detail: [
                {
                  key: 'Latitude',
                  value: props.latitudeVal,
                },
                {
                  key: 'Longitude',
                  value: props.longitudeVal,
                },
              ],
            },
          },
          {
            key: 'Tanda - tanda batas',
            value: {
              detail: [
                {
                  key: 'Utara',
                  value: props.tanda2BatasTanahUtaraVal,
                },
                {
                  key: 'Barat',
                  value: props.tanda2BatasTanahBaratVal,
                },
                {
                  key: 'Selatan',
                  value: props.tanda2BatasTanahSelatanVal,
                },
                {
                  key: 'Timur',
                  value: props.tanda2BatasTanahTimurVal,
                },
              ],
            },
          },
          {
            key: 'Keterangan Beton',
            value:
              props.keteranganBetonVal == 1
                ? 'Beton'
                : `Bukan Beton - ${props.keteranganBetonSebutkanVal || ''}`,
          },
          {
            key: 'Peruntukkan Penggunaan BMD',
            value: props.peruntukkanVal,
          },
          {
            key: 'Bangunan Bertingkat',
            value:
              props.isBertingkatVal == 1
                ? 'Ya, bertingkat'
                : 'Tidak bertingkat',
          },
          {
            key: 'Bertingkat',
            value:
              props.isBertingkatVal == 1 ? props.bertingkatSeharusnyaVal : '-',
          },
          {
            key: 'Gambar',
            value: props.gambarVal,
          },
        ]
      } else {
        const biaya2Beban = props.alasanTidakAdaPVal === '0'
          || props.alasanTidakAdaPVal == 1
          || props.alasanTidakAdaPVal == 2
          ? 'Non Fisik/Biaya-biaya'
          : 'Fisik Tidak Ditemukan'
        titleCard.value = `${'Tidak Ada' + ' - '}${biaya2Beban}`

        data1.value = [
          {
            key: 'Keberadaan',
            value: 'Tidak Ada',
          },
          {
            key: 'Apakah Merupakan Biaya-Biaya/Beban',
            value: biayaBeban[props.alasanTidakAdaPVal],
          },
          {
            key: 'Alasan Tidak Ada Barang',
            value:
              props.alasanTidakAdaVal == 0
                ? 'Beban lainnya'
                : props.alasanTidakAdaVal == 1
                  ? 'Biaya setelah perolehan - Tidak diketahui aset induknya'
                  : props.alasanTidakAdaVal == 2
                    ? {
                      value: 'Biaya setelah perolehan - Diketahui aset induknya',
                      detail: [
                        {
                          key: 'PD/UKPD',
                          value: `${props.kolokPdUkpdVal} :: ${props.pdUkpdVal}`,
                        },
                        {
                          key: 'Kode Barang Induk',
                          value: props.kobarIndukVal,
                        },
                        {
                          key: 'Nama Barang Induk',
                          value: props.nabarIndukVal,
                        },
                        {
                          key: 'Register Induk',
                          value: props.registerBarangVal,
                        },
                      ],
                    }
                    : props.alasanTidakAdaVal == 3
                      ? 'Biaya perolehan - Tidak diketahui aset induknya'
                      : props.alasanTidakAdaVal == 4
                        ? {
                          value: 'Biaya perolehan - Diketahui aset induknya',
                          detail: [
                            {
                              key: 'PD/UKPD',
                              value: `${props.kolokPdUkpdVal} :: ${props.pdUkpdVal}`,
                            },
                            {
                              key: 'Kode Barang Induk',
                              value: props.kobarIndukVal,
                            },
                            {
                              key: 'Nama Barang Induk',
                              value: props.nabarIndukVal,
                            },
                            {
                              key: 'Register Induk',
                              value: props.registerBarangVal,
                            },
                          ],
                        }
                        : props.alasanTidakAdaVal == 5
                          ? {
                            value: 'Sebab Lain - Sebab Lainnya',
                            detail: [
                              {
                                key: 'Sebutkan',
                                value: props.alasanTidakAdaNoteVal,
                              },
                            ],
                          }
                          : props.alasanTidakAdaVal == 6
                            ? 'Sebab Lain - Kejadian Kahar (Force Majeure)'
                            : props.alasanTidakAdaVal == 7
                              ? 'Sebab Lain - Tenggelam/Amblas/Longsor'
                              : props.alasanTidakAdaVal == 8
                                ? 'Sebab Lain - Susut'
                                : props.alasanTidakAdaVal == 9
                                  ? 'Sebab Lain - Terbakar'
                                  : props.alasanTidakAdaVal == 10
                                    ? 'Sebab Lain - Hilang Karena Kecurian'
                                    : props.alasanTidakAdaVal == 11
                                      ? 'Hilang'
                                      : props.alasanTidakAdaVal == 12
                                        ? {
                                          value: 'Sudah Dihapus (Sudah Keluar SK Penghapusan)',
                                          detail: [
                                            {
                                              key: 'Nomor SK Penghapusan',
                                              value: props.noSkPenghapusanVal,
                                            },
                                          ],
                                        }
                                        : props.alasanTidakAdaVal == 13
                                          ? {
                                            value: 'Transfer Antar PD/UKPD',
                                            detail: [
                                              {
                                                key: 'PD/UKPD',
                                                value: `${props.kolokPdUkpdVal} :: ${props.pdUkpdVal}`,
                                              },
                                            ],
                                          }
                                          : props.alasanTidakAdaVal == 14
                                            ? {
                                              value: 'Sudah Dibongkar Tanpa SK dan Belum Dihapus',
                                              detail: [
                                                {
                                                  key: 'PD/UKPD',
                                                  value: `${props.kolokPdUkpdVal} :: ${props.pdUkpdVal}`,
                                                },
                                              ],
                                            }
                                            : props.alasanTidakAdaVal == 15
                                              ? {
                                                value: 'Sudah Dibongkar, Sudah Ada SK dan Belum Dihapus',
                                                detail: [
                                                  {
                                                    key: 'Nomor SK Penghapusan',
                                                    value: props.noSkPenghapusanVal,
                                                  },
                                                ],
                                              }
                                              : '',
          },
        ]
      }
    })

    const checkCatatan = val => {
      if (!val && statusPersetujuan.value == 0) return false

      return true
    }

    // validation
    const requiredMsg = 'tidak boleh kosong'
    const $externalResults = ref({})
    const rules = computed(() => ({
      statusPersetujuan: {
        required: helpers.withMessage(
          `Status Persetujuan ${requiredMsg}`,
          required,
        ),
      },
      catatan: {
        checkCatatan,
      },
    }))

    const v$ = useVuelidate(
      rules,
      { statusPersetujuan, catatan },
      { $externalResults, $autoDirty: true },
    )

    const submitForm = async () => {
      isSubmit.value = true
      const isFormCorrect = await v$.value.$validate()
      // you can show some extra alert to the user or just leave the each field to show it's `$errors`.
      // jika error validasi

      if (!isFormCorrect) {
        isSubmit.value = false
        return
      }

      // mapping data
      const data = {
        validasi_sensus: statusPersetujuan.value,
        validasi_sensus_note:
          statusPersetujuan.value === '1' ? '' : catatan.value,
        id_emp: g.$cookies.get('username'),
        id: props.id,
      }

      await validasiKeberadaan.validasi(g, data)
      isSubmit.value = false
    }

    const validateState = item => {
      const { $dirty, $error } = item
      return !$dirty ? null : $error ? false : null
    }

    const resetForm = () => {}

    return {
      v$,
      $externalResults,
      titleCard,
      isSubmit,
      kodeLokasi,
      kib,
      kodeBarang,
      namaBarang,
      kodeRegisterBarang,
      catatan,
      statusPersetujuan,
      dataKodeLokasi,
      dataKib,
      resetForm,
      validateState,
      submitForm,

      data1,
      fieldData1,
    }
  },
}
</script>

<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-select.scss";
</style>
